import {getPostByPath} from './post';

export const apiPost = {
  getPostByPath,
};
